var exports = {
  "button": "MediaPlaybackRate.module__button___OHNRQk",
  "small": "MediaPlaybackRate.module__small___OHNRQk",
  "medium": "MediaPlaybackRate.module__medium___OHNRQk",
  "large": "MediaPlaybackRate.module__large___OHNRQk",
  "active": "MediaPlaybackRate.module__active___OHNRQk",
  "label": "MediaPlaybackRate.module__label___OHNRQk",
};

__webpack_require__.r(module.exports = exports);
